import React from 'react';

/**
 * DarijaPro Logo — wordmark only.
 * "Darija" in blue→purple brand gradient + "Pro" in muted slate.
 *
 * Props:
 *   size       'sm' | 'md' | 'lg' (default 'md')
 *   dark       boolean — adjusts the muted "Pro" shade for dark backgrounds
 *   className  extra classes for the outer wrapper
 */
const Logo = ({ size = 'md', dark = false, className = '' }) => {
  const sizes = {
    sm: 'text-base',
    md: 'text-xl',
    lg: 'text-2xl',
  };
  const txt = sizes[size] || sizes.md;
  return (
    <span className={`font-bold tracking-tight ${txt} ${className}`}>
      <span className={dark ? 'text-white' : 'text-slate-900'}>Darija</span>
      <span className={dark ? 'text-slate-300' : 'text-slate-400'}>Pro</span>
    </span>
  );
};

export default Logo;
